import { validateEmail } from '../helpers/emailHelper';

function checkEmptyFields(emails: any[]) {
  return emails.some((emailObj) => emailObj.email.length < 1);
}

function shareWithSelf(emails: any[], myEmail: String) {
  return emails.some((emailObj) => emailObj.email.toLowerCase() === myEmail.toLowerCase());
}

function validateField(emails: any[]) {
  return emails.some((emailObj) => validateEmail(emailObj.email) === null);
}

export default {
  checkEmptyFields,
  validateField,
  shareWithSelf,
};
